
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class EventHorizonEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;
        const radius = 200 * scale;

        ctx.strokeStyle = pc.color;

        const draw = () => {
             // Inward spiral lines
             const lines = Math.floor(40 * (config.parallaxComplexity || 1.0));
             for (let i = 0; i < lines; i++) {
                 ctx.save();
                 ctx.rotate((i / lines) * Math.PI * 2 + curTime * 0.1);
                 ctx.beginPath();
                 ctx.lineWidth = (1 + i * 0.1) * scale / layerIndex;
                 const startR = radius + Math.sin(curTime + i) * 50;
                 ctx.moveTo(startR, 0);
                 ctx.quadraticCurveTo(startR * 0.5, startR * 0.5, 0, 0);
                 ctx.stroke();
                 ctx.restore();
             }
             
             // Accretion disk glow
             ctx.save();
             ctx.globalAlpha *= 0.2;
             const grad = ctx.createRadialGradient(0, 0, radius * 0.8, 0, 0, radius * 1.5);
             grad.addColorStop(0, 'transparent');
             grad.addColorStop(0.5, pc.color);
             grad.addColorStop(1, 'transparent');
             ctx.fillStyle = grad;
             ctx.beginPath();
             ctx.arc(0, 0, radius * 1.5, 0, Math.PI * 2);
             ctx.fill();
             ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
